import { SectionVM } from 'civil-status/view-models/step-form';

export const dataMaintenanceSection = (currentSection: SectionVM | undefined): SectionVM => {
  return {
    codeSection: currentSection?.codeSection,
    configuration: currentSection?.configuration || '',
    typePresence: currentSection?.typePresence || '',
    typePersistence: currentSection?.typePersistence || '',
    isSaved: currentSection?.isSaved,
    idCertSanitario: currentSection?.idCertSanitario,
    idDatiEventoRiconoscimento: currentSection?.idDatiEventoRiconoscimento,
    // idEnteDichiarante: currentSection?.idEnteDichiarante,
    // idAttoCollegato: currentSection?.idAttoCollegato,
    idConsenso: currentSection?.idConsenso,
    idLuogo: currentSection?.idLuogo,
    idCertificatoUnioneCivile: currentSection?.idCertificatoUnioneCivile,
    idImpedimento: currentSection?.idImpedimento,
    idCertificato: currentSection?.idCertificato,
    idRegimePatrimoniale: currentSection?.idRegimePatrimoniale,
    idPubblicazione: currentSection?.idPubblicazione,
    riconoscimentoList: currentSection?.riconoscimentoList,
  };
};
